export default __webpack_public_path__ + "static/media/mana14.ae008e79.svg";